import { SpecialHourDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';

import SpecialHour from '../interfaces/SpecialHour';

export function fromDto(specialHourDto: SpecialHourDto): SpecialHour {
  const { uuid, isOpen, opensDate, closesDate } = specialHourDto;
  return { uuid, isOpen, opensDate: moment(opensDate), closesDate: moment(closesDate) };
}

export function toDto(specialHourDto: SpecialHour): SpecialHourDto {
  const { uuid, isOpen, opensDate, closesDate } = specialHourDto;
  return { uuid, isOpen, opensDate: opensDate.toISOString(), closesDate: closesDate.toISOString() };
}
